import React from "react";
import API_URL from "../../config/apiConfig";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { apiPost } from "../../util/axiosUtil";
import MutationHandler from "../../util/MutationHandler";

const unlinkMeetingFn = async (hostId) => {
  return apiPost(`${API_URL}/api/hosts/${hostId}/remove-meeting`);
};

const UnlinkMeeting = ({ onCancel, data, onSuccess }) => {
  return (
    <MutationHandler
      mutationFn={() => unlinkMeetingFn(data.id)}
      onCancel={onCancel}
      onSuccess={onSuccess}
    >
      {(mutation) => (
        <>
          <div className="sm:flex sm:items-start">
            <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <ExclamationTriangleIcon
                aria-hidden="true"
                className="h-6 w-6 text-red-600"
              />
            </div>
            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  Are you sure you want to unlink meeting from Host?
                </p>
              </div>
            </div>
          </div>

          <div className="mt-5 sm:mt-4 sm:flex sm:space-x-3 md:justify-end md:flex">
            <button
              type="button"
              onClick={() => mutation.mutate()}
              className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:w-auto"
              disabled={mutation.isPending}
            >
              {mutation.isPending ? "Unlink..." : "Unlink Meeting"}
            </button>
            <button
              type="button"
              onClick={onCancel}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Cancel
            </button>
          </div>
        </>
      )}
    </MutationHandler>
  );
};

export default React.memo(UnlinkMeeting);
